import { apolloClient } from '@/store/graphql.config'
import { fetchGenerateTokenMutation } from '@/store/modules/auth/mutations/fetchGenerateToken.mutation'
import { IFetchTokenResponse } from '@/store/modules/auth/interfaces/fetchGenerateToken/IFetchTokenResponse'
import { IFetchTokenRequest } from '@/store/modules/auth/interfaces/fetchGenerateToken/IFetchTokenRequest'
import { ISetUserVerificationRequest } from '@/store/modules/auth/interfaces/setUserVerification/ISetUserVerificationRequest'
import { ISetUserVerificationPhoneRequest } from '@/store/modules/auth/interfaces/setUserVerification/ISetUserVerificationPhoneRequest'

import { ISetFirstLogin } from '@/store/modules/auth/interfaces/setFirstLogin/ISetFirstLogin'
import { IFetchUserInfoResponse } from '@/store/modules/auth/interfaces/getUserInfo/IFetchUserInfoResponse'
import { ActionTree, MutationTree, GetterTree } from 'vuex'
import { AuthActionTypes } from '@/store/modules/auth/interfaces/action-types'
import { IRootState } from '@/store'
import { IAuthAction } from '@/store/modules/auth/IAuthAction'
import {
  getUserInformationAPI, setUserVerificationAPI, setFirstLogin, setUserVerificationPhoneAPI,
  getDefaultShipToAPI, setUserReValidateAPI
} from '@/store/modules/auth/services/auth.api'
import { IAuthState } from '@/store/modules/auth/IAuthState'
import { AuthMutationTypes } from '@/store/modules/auth/interfaces/mutation-types'
import { IUser } from '../users/interfaces/IUser'
import {
  ISetUserReValidatePhoneRequest
} from '@/store/modules/auth/interfaces/setUserVerification/ISetUserReValidatePhoneRequest'

const state = (): IAuthState => ({
  token: '',
  UID: '',
  UIDSig: '',
  loginWidgetLoaded: false,
  UIDSignature: '',
  errorCode: 0,
  errorMessage: '',
  id_token: '',
  lang: 'en',
  status: '',
  statusMessage: '',
  user: {
    UID: '',
    UIDSig: '',
    UIDSignature: '',
    emailLogin: false,
    showTutorial: 0,
    age: '',
    birthday: '',
    birthMonth: '',
    birthYear: '',
    city: '',
    country: '',
    email: '',
    firstName: '',
    firstLogin: false,
    lastName: '',
    username: '',
    gender: '',
    id_token: '',
    companyId: '',
    permissionSchema: [],
    allAvailablePermission: [],
    allAvailableRpDetails: [],
    isConnected: false,
    isKeyAccount: false,
    isLoggedIn: false,
    isSiteUID: false,
    isSiteUser: false,
    isTempUser: false,
    locale: null,
    loginProvider: '',
    loginProviderUID: '',
    nickname: '',
    phone: '',
    photoURL: '',
    profileURL: '',
    providers: [],
    state: '',
    statusCode: 0,
    statusReason: '',
    userValidation: false,
    work: '',
    zip: '',
    distributor: false,
    ontrade: false
  },
  isUserVerified: false,
  isUserVerifiedByPhone: false,
  isUserReValidate: false,
  isLanguageLoaded: false,
  isFullLoaded: false,
  defaultShipTo: ''
})
const mutations: MutationTree<IAuthState> = {
  async [AuthMutationTypes.SET_GENERATE_TOKEN] (state, payload: string) {
    state.token = payload
  },
  async [AuthMutationTypes.SET_WIDGET] (state, payload: boolean) {
    state.loginWidgetLoaded = payload
  },
  async [AuthMutationTypes.SET_AUTH_USER] (state, payload: IAuthState) {
    if (!state.user.UID || state.user.UID !== payload.user.UID) {
      state.user = payload.user
      state.user.username = state.user.firstName + ' ' + state.user.lastName
      // console.info('SET_AUTH_USER', payload.user.email, payload.id_token)
      sessionStorage.setItem('id_token', payload.id_token)
    }
  },

  async [AuthMutationTypes.SET_USER_NEW_INFO] (state, payload: IUser) {
    if (payload.firstName) state.user.firstName = payload.firstName
    if (payload.lastName) state.user.lastName = payload.lastName
    if (payload.email) state.user.email = payload.email
    if (payload.phone) state.user.phone = payload.phone
  },

  async [AuthMutationTypes.SET_USER_VERIFICATION] (state, payload: boolean) {
    state.isUserVerified = payload
  },
  async [AuthMutationTypes.SET_USER_VERIFICATION_PHONE] (state, payload: boolean) {
    state.isUserVerifiedByPhone = payload
  },
  async [AuthMutationTypes.SET_USER_RE_VALIDATE] (state, payload: boolean) {
    state.isUserReValidate = payload
  },
  async [AuthMutationTypes.SET_USER_INFO] (state, payload: IFetchUserInfoResponse) {
    const multipleCustomerType = localStorage.getItem('multipleCustomerType') || ''
    if (multipleCustomerType && multipleCustomerType !== '') {
      const permission = payload.permissionSchema.filter((item : any) => item.rpDetails[0].customerType === multipleCustomerType)

      state.user.companyId = permission[0].companyId
      state.user.permissionSchema = permission
      state.user.allAvailablePermission = permission?.flatMap((company) => company.rpDetails)
        ?.flatMap((rp) => rp.permission.split(','))
        ?.filter((value, index, self) => self.indexOf(value) === index) || []
    } else {
      state.user.companyId = payload.permissionSchema[0].companyId
      state.user.permissionSchema = payload.permissionSchema
      state.user.allAvailablePermission =
      payload.permissionSchema
        ?.flatMap((company) => company.rpDetails)
        ?.flatMap((rp) => rp.permission.split(','))
        ?.filter((value, index, self) => self.indexOf(value) === index) || []
    }
    state.user.phone = payload.phone
    state.user.distributor = payload.distributor
    state.user.ontrade = payload.ontrade
    state.isFullLoaded = true
    state.user.firstLogin = payload.firstLogin
    state.user.showTutorial = payload.showTutorial
    state.user.userValidation = payload.userValidation
    state.user.isKeyAccount = payload.isKeyAccount
    state.user.emailLogin = payload.emailLogin
    state.user.allAvailableRpDetails = payload.permissionSchema
  },
  [AuthMutationTypes.SET_LANGUAGE_LOADED] (state, payload: boolean): void {
    state.isLanguageLoaded = payload
  },
  [AuthMutationTypes.SET_DEFAULT_SHIP_TO] (state, payload: string) {
    state.defaultShipTo = payload
  }
}

const actions: ActionTree<IAuthState, IRootState> & IAuthAction = {
  async [AuthActionTypes.FETCH_GENERATE_TOKEN] ({ commit }, dto: IFetchTokenRequest) {
    const { data } = await apolloClient.mutate<IFetchTokenResponse, IFetchTokenRequest>({
      mutation: fetchGenerateTokenMutation,
      variables: {
        email: dto.email,
        password: dto.password
      }
    })
    localStorage.setItem('token', JSON.stringify(data?.generateCustomerToken.token))
    commit(AuthMutationTypes.SET_GENERATE_TOKEN, data?.generateCustomerToken.token || '')
  },
  async [AuthActionTypes.SET_USER_VERIFICATION] ({ commit }, dto: ISetUserVerificationRequest) {
    const data = await setUserVerificationAPI(dto)
    commit(AuthMutationTypes.SET_USER_VERIFICATION, data)
  },

  async [AuthActionTypes.SET_USER_VERIFICATION_PHONE] ({ commit }, dto: ISetUserVerificationPhoneRequest) {
    const data = await setUserVerificationPhoneAPI(dto)
    commit(AuthMutationTypes.SET_USER_VERIFICATION_PHONE, data)
  },
  async [AuthActionTypes.SET_USER_RE_VALIDATE] ({ commit }, dto: ISetUserReValidatePhoneRequest) {
    const data = await setUserReValidateAPI(dto)
    commit(AuthMutationTypes.SET_USER_RE_VALIDATE, data)
  },
  async [AuthActionTypes.SET_FIRST_LOGIN] ({ commit }, UID: ISetFirstLogin) {
    const data = await setFirstLogin(UID)
    commit(AuthMutationTypes.SET_FIRST_LOGIN, data)
  },
  async [AuthActionTypes.GET_USER_INFO] ({ commit, getters }, UID: string) {
    const multipleCustomerType = localStorage.getItem('multipleCustomerType') || ''
    if ((!getters.getUser.userValidation || getters.getUser.UID !== UID) || (multipleCustomerType !== '')) {
      const data = await getUserInformationAPI(UID)
      if (data.distributor && !data.ontrade) {
        localStorage.setItem('customertype', 'Distributor')
      }
      if (!data.distributor && data.ontrade) {
        localStorage.setItem('customertype', 'Ontrade')
      }

      commit(AuthMutationTypes.SET_USER_INFO, data)

      const defaultShipTo = localStorage.getItem('defaultShipTo') || ''
      if (multipleCustomerType !== '' && (!defaultShipTo || defaultShipTo === '' || defaultShipTo === 'null')) {
        const result = data.permissionSchema.filter((item : any) =>
          item.rpDetails.some((role : any) => role.customerType === multipleCustomerType)
        )

        // Return the `shipToId` of the first matching entry or null if no match
        const shiptoId = result.length > 0 ? result[0].shipToId : null

        localStorage.setItem('defaultShipTo', shiptoId)
        localStorage.setItem('shipToId', shiptoId)
        commit(AuthMutationTypes.SET_DEFAULT_SHIP_TO, shiptoId)
      } else if (!defaultShipTo || defaultShipTo === '' || defaultShipTo === 'null') {
        let defaultShipToId = ''
        if (!data.defaultShipToID) {
          defaultShipToId = data.permissionSchema[0].shipToId
        } else {
          defaultShipToId = data.defaultShipToID
        }
        localStorage.setItem('defaultShipTo', defaultShipToId)
        localStorage.setItem('shipToId', defaultShipToId)
        commit(AuthMutationTypes.SET_DEFAULT_SHIP_TO, defaultShipToId)
      }
    }
  }
  // async [AuthActionTypes.GET_DEFAULT_SHIP_TO] ({ commit }) {
  //   const defaultShipTo = localStorage.getItem('defaultShipTo') || ''
  //   if (defaultShipTo === '') {
  //     const data = await getDefaultShipToAPI()
  //     localStorage.setItem('defaultShipTo', data)
  //     localStorage.setItem('shipToId', data)
  //     commit(AuthMutationTypes.SET_DEFAULT_SHIP_TO, data)
  //   }
  // }
}

const getters: GetterTree<IAuthState, IRootState> & {
  getIsFullLoaded(state: IAuthState): () => boolean
} = {
  getIsFullLoaded (state) {
    return function () {
      return state.isFullLoaded // && state.isLanguageLoaded
    }
  },
  getUser (state: IAuthState) {
    return state.user
  }
}

const AuthModule = {
  state,
  mutations,
  actions,
  getters
}

export default AuthModule
